export default {"src":"/_next/static/media/sparks.a48cde73.svg","height":161,"width":101,"blurWidth":0,"blurHeight":0};